/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useRef } from 'react';

export default function useStableHandlers<T extends Record<string, (...args: any[]) => any>>(handlers: T): T {
  const stableRef = useRef(handlers);

  useEffect(() => {
    stableRef.current = handlers;
  }, [handlers]);

  return useMemo(() => {
    const proxy: any = {};
    for (const key in handlers) {
      proxy[key] = (...args: any[]) => stableRef.current[key]?.(...args);
    }
    return proxy as T;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
